'use client';

import { useRouter } from 'next/navigation';
import { Container, SectionLabel, SectionRule } from '../ReferenceChrome';

export function BottomCTARef() {
  const router = useRouter();

  return (
    <section className="relative pb-16 sm:pb-24">
      <SectionRule />
      {/* Background clipped to content column — does not bleed into gutter stripes */}
      <div
        className="rail-inset-abs pointer-events-none absolute inset-0 bg-gradient-to-b from-[#129990]/[0.05] to-white"
        aria-hidden
      />
      <Container className="relative text-center pt-16 sm:pt-24">
        <SectionLabel>Get Started Today</SectionLabel>
        <h2 className="mx-auto mt-4 max-w-xl text-3xl font-normal leading-tight tracking-tight text-gray-900 sm:text-[2.25rem]">
          Stop guessing about your SEO.
        </h2>
        <p className="mx-auto mt-4 max-w-md text-base font-light leading-relaxed text-gray-500">
          Connect Search Console, get a clear read on what matters, and leave with
          a small next step.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center">
          <button
            type="button"
            onClick={() => router.push('/sign-up')}
            className="relative flex items-center justify-center rounded-md border border-[#129990]/50 bg-gradient-to-r from-[#129990] to-[#1EAD9F] px-8 py-3 text-sm font-medium text-white shadow-[inset_0_1px_0px_rgba(255,255,255,0.2),0_0_0_1px_rgba(18,153,144,0.3),0_2px_6px_0_rgba(18,153,144,0.25)] transition-all duration-75 hover:brightness-105 active:translate-y-[2px] active:shadow-[inset_0_1px_0px_rgba(255,255,255,0.2),0_0_0_1px_rgba(18,153,144,0.3)] cursor-pointer"
          >
            Get started free
          </button>
        </div>
      </Container>
    </section>
  );
}
